import digital from "../Assets/Images/course/digital.jpg";
import videoEditing from "../Assets/Images/course/videoediting.jpg";
import design from "../Assets/Images/course/design.jpg";
import photoshop from "../Assets/Images/course/icons/edit/photoshop.png";
import illustrator from "../Assets/Images/course/icons/edit/illustrator.png";
import mediaEncoder from "../Assets/Images/course/icons/edit/media-encoder.png";
import photoshopLightroom from "../Assets/Images/course/icons/edit/photoshop-lightroom.png";
import afterEffects from "../Assets/Images/course/icons/edit/after-effects.png";
import premierePro from "../Assets/Images/course/icons/edit/premiere-pro.png";
import premiereRush from "../Assets/Images/course/icons/edit/premiere-rush.png";
import CapCutApp from "../Assets/Images/course/icons/edit/CapCut-app-Logo-Transparent.webp";
import google from "../Assets/Images/course/icons/digital/adwords.png";
import facebook from "../Assets/Images/course/icons/digital/facebook.png";
import meta from "../Assets/Images/course/icons/digital/meta.png";
import youtube from "../Assets/Images/course/icons/digital/youtube.png";
import seo from "../Assets/Images/course/icons/digital/seo.png";
import wordpress from "../Assets/Images/course/icons/digital/wordpress.png";
import linkedin from "../Assets/Images/course/icons/digital/linkedin.png";
import video from "../Assets/Images/course/3d.jpg";

export const courses = [
  {
    id: 1,
    category: "Digital Marketing",
    slug: "digital-marketing",
    title: "Advanced Digital Marketing",

    images: {
      img: digital,
    },
    courseInfo: {
      category: "Digital Marketing",
      instructor: "Arifin Arif",
      duration: "3 months",
      language: "Bangla",
      classes: "60",
    },

    price: {
      originalPrice: 10000,
      price: 7000,
    },

    info: {
      description:
        "Marketing through digital platforms has become a trendy topic in today’s world. Most of the people navigate online before buying any product. As a result, digital marketing has turned into a smart business strategy capable of drawing potential buyers by product promotion. This upwarding trend of online marketing might hit the mark of 786.2 billion dollar by 2026, estimated the global industry analysts. If you are keen to learn about online marketing strategies, or want to expand your business reach, enroll in this course now.",
    },

    skilsIcons: [
      { img: facebook, title: "Facebook" },
      { img: meta, title: "Meta" },
      { img: google, title: "Google Ads" },
      { img: youtube, title: "Youtube" },
      { img: linkedin, title: "Linkedin" },
      { img: wordpress, title: "Wordpress" },
      { img: photoshop, title: "Photoshop" },
      { img: seo, title: "SEO" },
    ],
  },

  {
    id: 2,
    category: "Professional Video Editing",
    slug: "professional-video-editing",
    title: "Professional Video Editing",

    images: {
      img: videoEditing,
    },
    courseInfo: {
      category: "Digital Marketing",
      instructor: "Arifin Arif",
      duration: "3 months",
      language: "Bangla",
      classes: "60",
    },

    price: {
      originalPrice: 15000,
      price: 10000,
    },

    info: {
      description:
        "A skilled editor considers several aspects of a video to come up with a great outcome. A study shows a professionally edited engaging video can boost product sales by 78%. Our comprehensive course module includes a range of topics and practical projects to gradually improve your skills. You will learn the basics of cinematography including lens selection and lighting. You can work in post-production and screenplay after course completion. ",
    },

    skilsIcons: [
      { img: photoshop, title: "Photoshop" },
      { img: illustrator, title: "Illustrator" },
      { img: mediaEncoder, title: "Media-Encoder" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: afterEffects, title: "After Effects" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: premierePro, title: "Photoshop-Lightroom" },
      { img: premiereRush, title: "Premiere Rush" },
      { img: CapCutApp, title: "CapCut" },
    ],
  },
  {
    id: 3,
    category: "professional 3d animation motion graphics",
    slug: "professional-3d-animation-motion-graphicsg",
    title: "Professional 3d Animation Motion Graphics",

    images: {
      img: video,
    },
    courseInfo: {
      category: "Digital Marketing",
      instructor: "Arifin Arif",
      duration: "3 months",
      language: "Bangla",
      classes: "60",
    },

    price: {
      originalPrice: 25000,
      price: 18000,
    },

    info: {
      description:
        "A skilled editor considers several aspects of a video to come up with a great outcome. A study shows a professionally edited engaging video can boost product sales by 78%. Our comprehensive course module includes a range of topics and practical projects to gradually improve your skills. You will learn the basics of cinematography including lens selection and lighting. You can work in post-production and screenplay after course completion. ",
    },

    skilsIcons: [
      { img: photoshop, title: "Photoshop" },
      { img: illustrator, title: "Illustrator" },
      { img: mediaEncoder, title: "Media-Encoder" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: afterEffects, title: "After Effects" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: premierePro, title: "Photoshop-Lightroom" },
      { img: premiereRush, title: "Premiere Rush" },
      { img: CapCutApp, title: "CapCut" },
    ],
  },

  {
    id: 4,
    category: "Graphics Design",
    slug: "graphics-design",
    title: "Professional Graphic Design",

    images: {
      img: design,
    },
    courseInfo: {
      category: "Digital Marketing",
      instructor: "Arifin Arif",
      duration: "3 months",
      language: "Bangla",
      classes: "60",
    },

    price: {
      originalPrice: 10000,
      price: 7000,
    },

    info: {
      description:
        "Considering the growing demand for visual content, marketers are promoting their products through graphical ideas nowadays. The increasing need for graphic designers has unlocked many opportunities for the people who prefer working independently. A study shows, all the companies prioritize their visual acceptance, even a small company spends up to 500 dollars to create a perfect logo. If you are passionate about making designs, this updated Graphic Design course is for you.",
    },

    skilsIcons: [
      { img: photoshop, title: "Photoshop" },
      { img: illustrator, title: "Illustrator" },
      { img: mediaEncoder, title: "Media-Encoder" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: afterEffects, title: "After Effects" },
      { img: photoshopLightroom, title: "Photoshop-Lightroom" },
      { img: premierePro, title: "Photoshop-Lightroom" },
      { img: premiereRush, title: "Premiere Rush" },
      { img: CapCutApp, title: "CapCut" },
    ],
  },
];
